import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { DispatchProps, OwnProps, StateProps } from './AgencyInfo';
import AgencyInfo from './AgencyInfo';
import { StoreState } from 'src/store/reducers';
import { getAgency, createFilesAgency } from 'src/store/actions/app-actions';
import { QueryParams } from 'src/types/grid';
import { toast } from 'react-toastify';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        agencyInfo: state.app.agencyInfo,
        miniLoaderFor: state.app.miniLoaderFor,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        addFiles: (id, files: any) =>
            dispatch(
                createFilesAgency(
                    id,
                    files,
                    () => toast.success('File added successfully'),
                    (errorMessage: string) => {
                        toast.error(errorMessage);
                    },
                ),
            ),
        getData: (params: QueryParams) => dispatch(getAgency(params)),
    };
}

const AgencyInfoScreen = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(AgencyInfo);

export default AgencyInfoScreen;
